import React, { useEffect, useState } from "react";
import NavbarVisitor from "../Component/NavbarVisitor";
import axios from "axios";
import { BASE_URL, IMAGE_URL } from "../Component/Baseurl";
import Footer from "../Component/Footer";
import defaultImage from "../Component/img/event1.jfif";
import { useParams, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const AllEventFilterFormat = () => {
  const [events, setEvents] = useState([]);  
  const [filteredEvents, setFilteredEvents] = useState([]);  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [industries, setIndustries] = useState([]);
  const [industry, setIndustry] = useState("");
  const { format } = useParams(); // Use format instead of industry
  const navigate = useNavigate();

  const [selectedTimeFrames, setSelectedTimeFrames] = useState([]);

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;

  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const response = await axios.get(`${BASE_URL}getAllIndustryByWorkshop`);  
        if (response.data.success) {
          setIndustries(response.data.industries);
        }
      } catch (error) {
        console.error("Error fetching industries:", error);
      }
    };

    fetchIndustries();
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}getAllEventsByFormat/${format}`
        );
        console.log("API Response:", response); // Log the entire response to check its structure
        if (response.data.events) {
          setEvents(response.data.events);
          setFilteredEvents(response.data.events);
        } else {
          setError("Failed to fetch events");
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching events:", error);
        setError("Error fetching events");
        setLoading(false);
      }
    };
    fetchEvents();
  }, [format]);

  useEffect(() => {
    if (selectedTimeFrames.length === 0) {
        setFilteredEvents(events);
      return;
    }

    const today = new Date();
    const startOfWeek = new Date();
    startOfWeek.setDate(today.getDate() - today.getDay());

    const nextWeek = new Date();
    nextWeek.setDate(today.getDate() + 7);

    const thisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const nextThreeMonths = new Date(
      today.getFullYear(),
      today.getMonth() + 3,
      1
    );

    const filtered = events.filter((event) => {
      const eventDate = new Date(event.start_date);

      return selectedTimeFrames.some((timeFrame) => {
        switch (timeFrame) {
          case "Today":
            return eventDate.toDateString() === today.toDateString();
          case "Tomorrow":
            return (
              eventDate.toDateString() ===
              new Date(today.setDate(today.getDate() + 1)).toDateString()
            );
          case "This Week":
            return eventDate >= startOfWeek && eventDate <= nextWeek;
          case "Next Week":
            return (
              eventDate >= nextWeek &&
              eventDate <= new Date(nextWeek.setDate(nextWeek.getDate() + 7))
            );
          case "This Month":
            return (
              eventDate >= thisMonth &&
              eventDate <
                new Date(thisMonth.getFullYear(), thisMonth.getMonth() + 1, 1)
            );
          case "Next 3 Months":
            return eventDate >= today && eventDate < nextThreeMonths;
          default:
            return false;
        }
      });
    });

    setFilteredEvents(filtered);
  }, [selectedTimeFrames, events]);

  // Handle checkbox change
  const handleTimeFrameChange = (event) => {
    const { value, checked } = event.target;
    setSelectedTimeFrames((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  // Calculate paginated events
  const indexOfLastEvent = currentPage * itemsPerPage;
  const indexOfFirstEvent = indexOfLastEvent - itemsPerPage;
  const currentEvents = filteredEvents.slice(
    indexOfFirstEvent,
    indexOfLastEvent
  );

  // Get total number of pages
  const totalPages = Math.ceil(filteredEvents.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <span className="loader"></span>
        <p className="ms-3">Loading Content...</p>
      </div>
    );
  }

  if (error) return <p>{error}</p>;

  return (
    <>
      <NavbarVisitor />

      <div>
        <div className="container">
          <div className="row mt-3">
            <div className="col">
              <h2 className="text-start">All Events</h2>{" "}
              {/* Changed from "Workshops" to "Events" */}
            </div>
          </div>
        </div>

        <div className="bg-light">
          <div className="container py-4">
            <div className="row">
              <div className="col-md-3 text-start p-2 bg-white">
                <div>
                  <h3 className="ft-tags">Filter</h3>
                  <h2 className="ft-event1">Category</h2>
                  <hr className="my-2" />
                  <div>
                    {industries.length > 0 ? (
                      industries.map((ind, index) => (
                        <Link key={index} to={`/${ind.industry_name}`}>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              value={ind.industry_name}
                              id={`industry-${index}`}
                              checked={format === ind.industry_name} // Check using format
                              readOnly // Prevent manual change
                            />
                            <label
                              className="form-check-label d-flex justify-content-between"
                              htmlFor={`industry-${index}`}
                            >
                              <span className="industries2">
                                {ind.industry_name}
                              </span>
                              <span className="industries3">
                                ({ind.industry_count})
                              </span>
                            </label>
                          </div>
                        </Link>
                      ))
                    ) : (
                      <p>Loading industries...</p>
                    )}
                  </div>

                  <h2 className="ft-event1">Format</h2>
                  <hr className="my-2" />
                  <div>
                    {[
                      "Exhibition",
                      "Conference",
                      "Workshop",
                      "Concert",
                      "Sport",
                    ].map((format, index) => (
                      <div className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={format}
                          id={`format-${index}`}
                        />
                        <label
                          className="form-check-label d-flex justify-content-between"
                          htmlFor={`format-${index}`}
                        >
                          <Link
                            to={`/format/${format.toLowerCase()}`}
                            className="industries2"
                          >
                            {format}
                          </Link>
                        </label>
                      </div>
                    ))}
                  </div>

                  <h2 className="ft-event1">Calendar</h2>
                  <hr className="my-2" />
                  <div>
                    {[
                      "Today",
                      "Tomorrow",
                      "This Week",
                      "Next Week",
                      "This Month",
                      "Next 3 Months",
                    ].map((timeFrame, index) => (
                      <div className="form-check" key={index}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value={timeFrame}
                          id={`calendar-${index}`}
                          onChange={handleTimeFrameChange}
                        />
                        <label
                          className="form-check-label d-flex justify-content-between"
                          htmlFor={`calendar-${index}`}
                        >
                          <span className="industries2">{timeFrame}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="col-md-5">
                <div className="row g-1">
                  {currentEvents.map((event) => (
                    <div
                      key={event.event_unique_id}
                      className="col-md-12 col-12 mb-3"
                    >
                      <Link
                        to={`/${
                          event.source_table === "exhibition_master"
                            ? `exhibition/${event.event_slug}`
                            : event.source_table === "conference_master"
                            ? `conference/${event.event_slug}`
                            : event.source_table === "workshop_master"
                            ? `${event.event_slug}/workshop`
                            : event.source_table === "concert_master"
                            ? `${event.event_slug}/concert`
                            : event.source_table === "sport_master"
                            ? `${event.event_slug}/sport`
                            : event.event_slug // Fallback URL
                        }`} target="_blank"
                        className="event-card-link"
                      >
                        <div className="event-card">
                          <div className="d-flex text-start justify-content-between">
                            <div className="p-3 text-start">
                              <span className="ft-tags">
                                {new Date(event.start_date).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "2-digit",
                                  }
                                )}{" "}
                                ,{" "}
                                {new Date(event.end_date).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "short",
                                    year: "2-digit",
                                  }
                                )}
                              </span>

                              <h4 className="ft-event">{event.event_name}</h4>

                              <h6 className="plaq">{event.venue_name}</h6>
                              <p className="p1">{event.venue_address}</p>
                              <div className="badge bg-gradient-primary etype">
                                {event.frequency || "N/A"}
                              </div>
                            </div>
                            <div className="p-3">
                              <img
                                src={
                                  event.eventbanner
                                    ? `${IMAGE_URL}eventFiles/${event.eventbanner}`
                                    : defaultImage
                                }
                                alt={event.event_name}
                                className="img-fluid eventimg2"
                              />
                            </div>
                          </div>

                          <div className="event-details text-start px-3 pb-3">
                            <div>{event.organised_by}</div>
                            {/* Display Industries */}
                            {event.industries &&
                              event.industries.length > 0 && (
                                <div className="industries">
                                  {event.industries.map((industry, index) => (
                                    <span key={index}>#{industry} </span>
                                  ))}
                                </div>
                              )}
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </div>

                {/* Pagination - Page numbers */}
                <div className="d-flex justify-content-center mt-4">
                  {Array.from({ length: totalPages }, (_, index) => (
                    <button
                      key={index + 1}
                      className={`btn btn-primary me-2 ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                      onClick={() => paginate(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                </div>
              </div>
              <div className="col-md-4"></div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default AllEventFilterFormat;
